module.exports = __webpack_public_path__ + "static/media/downArrow.31a69114.svg";